import React, { useContext } from "react";
import dayjs from "dayjs";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/airbnb.css";
import GroupContext from "../../context/group";

const flatpickrOptions = {
  enableTime: false,
  dateFormat: "m/d/Y",
  allowInput: false,
  position: "above",
  locale: {
    firstDayOfWeek: 1,
  },
  disableMobile: true,
  wrap: true,
};

const FormDatePicker = ({
  id,
  field,
  label,
  placeholder,
  validate,
  formatWarning,
  minDate,
  maxDate,
  isRequired = false,
  ...other
}) => {
  const { formData, onChange, formErrors } = useContext(GroupContext);
  const currentValue = formData[field];
  // console.log('currentValue: ', currentValue)
  const options = {
    ...flatpickrOptions,
    ...(minDate ? { minDate } : null),
    ...(maxDate ? { maxDate } : null),
  };
  return (
    <Flatpickr
      options={options}
      value={currentValue}
      onChange={(e) => {
        onChange({
          target: {
            type: "text",
            name: field,
            value: dayjs(e[0]).format("MM/DD/YYYY"),
          },
        });
      }}
    >
      <label className="form__input-label flatpickr" htmlFor={id}>
        <span>{label}</span>
        <input
          className="form__input"
          type="text"
          id={id}
          name={field}
          aria-label={label || placeholder}
          value={currentValue}
          placeholder={placeholder}
          data-required={isRequired}
          data-input
          {...other}
        />
        {formErrors[field] && (
          <span className="form__error-message d-inline">
            {currentValue ? formatWarning : formErrors[field]}
          </span>
        )}
      </label>
    </Flatpickr>
  );
};

export default FormDatePicker;
